module.exports = __webpack_public_path__ + "img/pexels-photo-3369239.23dc6fcb.jpeg";